import { AxiosInstance } from "axios";
import { Community, CommunityFeed } from "../types";
import { generateApiUrlWithQueryParams } from "../utils/query-params";

export const basePath = "/communities";

// All the paths for this api domain.
export const communityPaths = {
  getBySlug: (slug: string) => basePath + `/${slug}`,

  getFeed: (slug: string, queryParams?: string) =>
    generateApiUrlWithQueryParams(`${basePath}/${slug}/feed`, queryParams),

  getStaticCommunitySlugs: () => "/community-slugs",
};

class CommunityApi {
  api: AxiosInstance;

  constructor(api: AxiosInstance) {
    this.api = api;
  }

  // Get community by slug.
  // GET /communities/<slug>
  getBySlug = (communitySlug: string) => {
    return this.api.get<Community>(communityPaths.getBySlug(communitySlug));
  };

  // Get the community's feed by slug.
  // GET /communities/<slug>/feed
  getFeed = (communitySlug: string, queryParams?: string) => {
    return this.api.get<CommunityFeed>(
      communityPaths.getFeed(communitySlug, queryParams)
    );
  };

  // Get slugs for the communities that will be statically generated at build time
  // based on the prerenderPage value in its options.staticGeneration meta record.
  // GET /community-slugs
  getStaticCommunitySlugs = () => {
    return this.api.get(communityPaths.getStaticCommunitySlugs());
  };
}

export default CommunityApi;
